/* Dansk katalog for locale-bank-kje09-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'bank.group.toast.booked': 'Matchgruppen er bogført samlet.',
  'bank.group.err.bookUnavailable': 'Matchgruppen blev godkendt, men bogføring er ikke tilgængelig.',
  'bank.group.err.bookFailed': 'Kunne ikke bogføre matchgruppen.',
  'bank.group.book': 'Bogfør gruppe',
  'bank.resolve.reversePaymentInfo': 'Tilbageførsel ophæver betalingen med sporbarhed, genåbner leverandørfakturaen og åbner banklinjen for ny kontrol.',
  'err.bankMatchReversalReason': 'Angiv en årsag til, at bankkoblingen tilbageføres.',
});
